// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3usj-","right":"styles_right__1VkX5"};